import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, PropType, watch, onMounted } from "vue";
import GridFiltersBase from "@/components/ui/grid/grid-filters-base.vue";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { CodeType } from "acquaint-api/constants/CodeType";
import SystemCodeSingleSelect from "@/components/ui/system-codes/system-code-single-select.vue";
import { MaintenanceRequestListFilters } from "@/types/maintenance-requests/MaintenanceRequestListFilters";


export default /*#__PURE__*/_defineComponent({
  __name: 'maintenance-requests-filters-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * An object containing filters for the maintenance request list.
   * Used to apply specific filtering criteria to the list of maintenance request records.
   * @type {MaintenanceRequestListFilters}
   */
  filter: {
    type: Object as PropType<MaintenanceRequestListFilters>,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Emitted when filters are applied in the modal.
   * @property {Object} filters - The filter values applied to the maintenance request list.
   */
  "filtersApplied",
],
  setup(__props, { emit }) {

const props = __props;





onMounted(() => {
  clonePropFilters();
});

watch(
  () => props.modelValue,
  () => {
    if (!props.modelValue) {
      return;
    }

    // Need to clone the passed filters to avoid them updating before the user clicks the apply button
    clonePropFilters();
  },
);

const clonePropFilters = () => {
  if (props.filter) {
    modalFilter.value = JSON.parse(JSON.stringify(props.filter));
  } else {
    modalFilter.value = {
      status: { id: -1, description: "All" },
      branch: { id: -1, description: "All" },
    };
  }
};

/** Handles the filters applied event from the grid filters base */
const onFiltersApplied = () => emit("filtersApplied", modalFilter.value);

/** Handles the clear filters event from the grid filters base */
const onClearFilters = () => {
  modalFilter.value.status = { id: -1, description: "All" };
  modalFilter.value.branch = { id: -1, description: "All" };
};

const modalFilter = ref<MaintenanceRequestListFilters>({
  status: { id: -1, description: "All" },
  branch: { id: -1, description: "All" },
});

const showFilters = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const onBranchChanged = (description: string) => {
  modalFilter.value.branch.description = description;
};

const onStatusValueChanged = (description: string) => {
  modalFilter.value.status.description = description;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GridFiltersBase, {
    "data-source": modalFilter.value,
    modelValue: showFilters.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showFilters).value = $event)),
    title: "Maintenance Request Filters",
    onClearFilters: onClearFilters,
    onFiltersApplied: onFiltersApplied
  }, {
    filters: _withCtx(() => [
      _createVNode(SystemCodeSingleSelect, {
        label: "Status",
        modelValue: modalFilter.value.status.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modalFilter.value.status.id) = $event)),
        showClearButton: true,
        "code-type": _unref(CodeType).MaintenanceRequestStatus,
        onValueChanged: onStatusValueChanged
      }, null, 8, ["modelValue", "code-type"]),
      _createVNode(LookupSingleSelect, {
        label: "Branch",
        modelValue: modalFilter.value.branch.id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modalFilter.value.branch.id) = $event)),
        showClearButton: true,
        "lookup-source": _unref(LookupTableSource).Sites,
        onValueChanged: onBranchChanged
      }, null, 8, ["modelValue", "lookup-source"])
    ]),
    _: 1
  }, 8, ["data-source", "modelValue"]))
}
}

})